<div class="ols-bedrag-tb" [ngClass]="{'has-error': hasError(), 'has-focus': bedragHasFocus}">
  <div class="ols-euro-tb" [innerHTML]="geefEuro()"></div>
  <input #BedragField [disabled]="!isCurrentVraag" [required]="bedragRequired" type='text' name='bedrag'
    (focus)='setBedragFocus(true)' (blur)='setBedragFocus(false)' [(ngModel)]="bedrag" placeholder="{{placeholder}}"
    oninput="this.value=this.value.replace(/[^0-9,]/g,'')">
  <p class="error-block" *ngIf="!validBedrag() && !isBedragLeeg() && bedragHadFocus">{{errormessageBedrag}}</p>
  <p class="error-block" *ngIf="isBedragLeeg() && bedragHadFocus && bedragRequired">Het bedrag is verplicht</p>
  <p class="error-block" *ngIf="submitClicked && isBedragLeeg() && bedragHadFocus">Vul alsjeblieft het bedrag in</p>
</div>